import React, { useEffect, useRef, useState } from "react";

const Q35 = ({ textData, setTextData, nextAllowed, nextNavigate }) => {
    const [localData, setLocalData] = useState(
        [...Array(12)].map(() => {
            return "";
        })
    );
    const firstRestore = useRef(false);
    
    const handleData = (ind, val) => {
        setLocalData((prev) => {
            let prevCopy = [...prev];
            prevCopy[ind] = val;
            return prevCopy;
        });
    };

    useEffect(() => {
        if (!firstRestore.current) {
            firstRestore.current = true;
        } else if (localData.every(Boolean)) {
            setTextData(localData.join(""));
        } else {
            setTextData("");
        }
    }, [localData]);

    useEffect(() => {
        if (textData.length > 0) {
            setLocalData([...textData]);
        }
    }, [textData]);

    return (
        <div className="flex_col g1">
            <div className="flex_row justify-content_between">
                {["A", "B", "C"].map((v) => (
                    <div className="w33 subtitle text_center">{v}</div>
                ))}
            </div>
            <div className="flex_row flex_wrap justify-content_between g2">
                {localData.map((val, ind) => (
                    <input
                        key={ind}
                        type="text"
                        className="w33"
                        maxlength="1"
                        value={val}
                        required={true}
                        onChange={(e) => handleData(ind, e.target.value)}
                        onKeyDown={(e) => {
                            e.stopPropagation();
                            if (e.code === "Enter") {
                                e.preventDefault();
                                if (nextAllowed()) {
                                    nextNavigate();
                                }
                            }
                        }}
                    />
                ))}
            </div>
        </div>
    );
};

export default Q35;
